// Aynı input sınıf dizisi kod tabanında 8 yerde birebir kopyalanmıştı.
export default function Input({ icon: Icon, className = '', ...rest }) {
  return (
    <div className={`relative ${className}`}>
      {Icon && <Icon size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />}
      <input
        className={`w-full border border-slate-200 rounded-lg py-2 text-sm bg-white text-slate-800
                    placeholder:text-slate-400 transition-colors
                    focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100
                    ${Icon ? 'pl-9 pr-3' : 'px-3'}`}
        {...rest}
      />
    </div>
  );
}
